import type { DynamicKey, KeyType, TranslationKeysType } from './utils';
import { getOhTranslations, getOtTranslations } from './utils';

const replacePlaceholders = (keyValue: string, dynamicValue: Record<string, string>) => {
    const regex = /{{(.*?)}}/g;

    return keyValue.replace(regex, (match, placeholder: string) => {
        return dynamicValue[placeholder] ?? match;
    });
};

const shouldExposePhraseKey = () => new URLSearchParams(globalThis.location.search).get('phrase') === 'show';

const buildTranslator =
    (loadTranslations: () => Record<TranslationKeysType, string> | undefined) =>
    (key: KeyType, dynamicValue?: DynamicKey) => {
        if (shouldExposePhraseKey()) {
            return key;
        }

        const translations = loadTranslations();
        // oxlint-disable-next-line @typescript-eslint/consistent-type-assertions
        const translatedValue = translations?.[key as TranslationKeysType];

        if (!translatedValue) {
            return key;
        }

        return dynamicValue ? replacePlaceholders(translatedValue, dynamicValue) : translatedValue;
    };

export const translate: TranslateFunction = buildTranslator(getOtTranslations);
export const translateOrderHistory: TranslateFunction = buildTranslator(getOhTranslations);
export type TranslateFunction = (key: string, params?: Record<string, string>) => string;
